"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var paymentInfo = {
    PAYMENT_INFO: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment PaymentInfo on PaymentInfo {\n      errorCode\n      errorMessage\n      actionCode\n      actionDescription\n      transactionId\n      transactionTime\n      card\n      brand\n    }\n  "], ["\n    fragment PaymentInfo on PaymentInfo {\n      errorCode\n      errorMessage\n      actionCode\n      actionDescription\n      transactionId\n      transactionTime\n      card\n      brand\n    }\n  "]))),
};
exports.default = paymentInfo;
var templateObject_1;
